export const SET_BD_ADMIN = "SET_BD_ADMIN";
export const UNSET_BD_ADMIN = "UNSET_BD_ADMIN";
export const UPDATE_BD_ADMIN_PROFILE = "UPDATE_BD_ADMIN_PROFILE";

export const CREATE_AGENCY = "CREATE_AGENCY";
export const UPDATE_AGENCY_NAME = "UPDATE_AGENCY_NAME";
export const GET_BD_AGENCIES = "GET_BD_AGENCIES";
export const DELETE_AGENCY = "DELETE_AGENCY";
export const SEARCH_AGENCY_BY_CODE = "SEARCH_AGENCY_BY_CODE";
export const GET_AGENCY_HOST_STATS = "GET_AGENCY_HOST_STATS";

export const OPEN_AGENCY_DIALOG = "OPEN_AGENCY_DIALOG";
export const CLOSE_AGENCY_DIALOG = "CLOSE_AGENCY_DIALOG";
export const GET_BD_AGENCY_HISTORY = "GET_BD_AGENCY_HISTORY";
export const ENABLE_DISABLE_AGENCY = "ENABLE_DISABLE_AGENCY";